import { useEffect } from "react";

export const useWindowEvent = (event, callback, params = []) => {
  useEffect(() => {
    window.addEventListener(event, callback);
    return () => window.removeEventListener(event, callback);
  }, [event, callback, ...params]);
};
